module.exports = __webpack_public_path__ + "img/logo.1ce4fe2d.png";